// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customAdd[data-v-4c6718f3]:active {\n  outline: none;\n}\n.customAdd[data-v-4c6718f3] {\n  border-radius: 38px;\n  padding: 8px 16px;\n  border: 1px solid var(--colorBorder, rgba(0, 0, 0, 0.15));\n  background: var(--colorBgContainer, #fff);\n  -webkit-box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);\n          box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);\n}\n.customAdd[data-v-4c6718f3]:hover{\n  background-color:#FFDA69;\n  border: 1px solid #FFDA69;\n}\n", ""]);
// Exports
module.exports = exports;
